<template>
  <div id="app" ref="app" @scroll="appScroll">
    <!-- {{ua}} -->
    <ListHeader
      v-if="!wrongChannelId"
      ref="listHeader"
      :intro_info="intro_info"
      :block_info="block_info"
      @joinBtnClick="toDownload"
    />
    <div id="flock-list" class="flock-list g-wrap-padding">
      <FlockCard
        v-for="(item, index) in flockList"
        :key="index + 'flock'"
        :info="item"
        :isAndroid="isAndroid"
        :index="index"
        :videoActiveIndex="currentVideoIndex"
        @videoClick="videoClick"
        @likeClick="toDownload"
        @menuClick="toDownload"
        @cardClick="cardClick"
      />
      <Loading
        v-if="!wrongChannelId"
        :show="have_next === 'Y'"
        msg="更多精彩，敬请期待"
      />
      <div class="wrong-channel-id" v-if="wrongChannelId">没有找到这个堆</div>
    </div>
    <BottomBar :url="wap_share_url || '//app.myzaker.com'" />
  </div>
</template>

<script>
import ListHeader from "./components/ListHeader";
import FlockCard from "./components/FlockCard";
import BottomBar from "./components/BottomBar";
import Loading from "./components/Loading";
import api from "./apis";
import { parseQueryString } from "./utils";
import { setTimeout } from "timers";

let scrollTimer = null;
let anchorPoint = 0;
const shouldCache = /MicroMessenger|Weibo|QQ|ZAKER/.test(navigator.userAgent);

export default {
  name: "app",
  components: {
    ListHeader,
    FlockCard,
    BottomBar,
    Loading,
  },
  mounted() {
    const query = parseQueryString(location.search);
    this.wap_share_url = this.isAndroid
      ? "https://applink.myzaker.com/zaker/androidlink/"
      : "https://applink.myzaker.com/zaker/ioslink/";
    if (!query.channel_id) {
      this.wrongChannelId = true;
      this.have_next = "N";
      return;
    }
    this.channelId = query.channel_id;
    let $data = sessionStorage.getItem("$data");
    let requestParam = sessionStorage.getItem("requestParam");
    const top = (sessionStorage.getItem("top") || "").split(",");
    // if (!shouldCache || !$data || Date.now() - top[2] > 600000) {
    if (!shouldCache || !$data) {
      this.getFirstFlockPage(true);
      return;
    }
    $data = JSON.parse($data);
    this.requestParam = JSON.parse(requestParam);
    Object.assign(this, $data);
    if (+top[0] === +this.channelId) anchorPoint = +top[1];
    if (anchorPoint > 0) {
      setTimeout(() => {
        this.$refs.app.scrollTop = anchorPoint;
        sessionStorage.clear();
      }, 50);
    }
  },
  data() {
    return {
      flockList: [],
      intro_info: {},
      block_info: {},
      discussion_info: {},
      have_next: "Y",
      likeStore: {},
      hasJoined: false,
      isAndroid: /android/gi.test(navigator.userAgent),
      currentVideoIndex: -1,
      wap_share_url: "",
      // ua: navigator.userAgent,
      wrongChannelId: false,
    };
  },
  methods: {
    async getFirstFlockPage(firstLoad) {
      try {
        this.cardTransition = false;
        this.resetRequestParam();
        const res = await this.getFlockList();
        if (!res) return;
        this.share_url = res.share_url;
        // 头部高度
        this.headerHeight = res.intro_info.user_is_join === "Y" ? 50 : 116;
        (this.block_info = res.block_info),
          (this.discussion_info = res.discussion_info),
          (this.intro_info = res.intro_info),
          (this.have_next = res.have_next),
          (this.hasJoined = res.intro_info.user_is_join === "Y");
        this.flockList = this.flockList.concat(res.list);
        this.wap_share_url = res.wap_share_url;
        document.title = this.block_info.title + "-ZAKER";

        if (firstLoad) {
          this.initDocument();
          this.initWechat();
        }
      } catch (error) {
        console.error(error);
        if (firstLoad) {
          this.wrongChannelId = true;
        }
        this.have_next = "N";
      }
    },
    async getNextFlockPage() {
      if (this.have_next !== "Y") return;
      try {
        const res = await this.getFlockList();
        if (res) {
          this.flockList = this.flockList.concat(res.list);
          this.have_next = res.have_next;
        }
      } catch (error) {
        console.error(error);
      }
    },
    getFlockList() {
      return new Promise(async (resolve, reject) => {
        if (this.fetchingListLock) {
          resolve("");
          return;
        }
        this.fetchingListLock = true;
        try {
          const res = await api.flock.getFlockData({
            channel_id: this.channelId,
            page_from: "wap",
            ...this.requestParam,
          });
          this.requestParam = {
            last_time: res.last_time,
            next_page: res.next_page,
            next_pk: res.next_pk,
            timestamp: res.timestamp,
          };
          resolve(res);
        } catch (error) {
          console.error(error);
          reject(error);
        } finally {
          this.fetchingListLock = false;
        }
      });
    },
    initDocument() {
      // 插入 meta 标签
      let oMeta = document.createElement("meta");
      oMeta.content = this.intro_info.introduction;
      oMeta.name = "description";
      document.getElementsByTagName("head")[0].appendChild(oMeta);
    },
    initWechat() {
      // 微信设置
      try {
        // console.log(wxShareNew)
        //微信的设置
        var shareLink = window.location.href;
        var sharePic = this.intro_info.logo;
        var shareTitle = `${this.block_info.title}-ZAKER`;
        var shareDesc = this.intro_info.introduction;
        var shareTimelineDesc = this.intro_info.introduction;
        var sharesuccessFunc = function () {};
        var sharecancelFunc = function () {};
        let scriptdom = document.createElement("script");
        scriptdom.type = "text/javascript";
        scriptdom.src = "//app.myzaker.com/tools/wx_serv.php?v=1";
        document.body.appendChild(scriptdom);
        scriptdom.onload = function () {
          // eslint-disable-next-line
          wxShare.init(
            shareTitle,
            shareDesc,
            shareLink,
            sharePic,
            sharesuccessFunc
          );
        };
      } catch (error) {
        console.error(error);
      }
    },
    resetRequestParam() {
      this.requestParam = {
        last_time: "",
        next_page: "",
        next_pk: "",
        timestamp: "",
      };
    },
    appScroll() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        const { scrollHeight, scrollTop, offsetHeight } = this.$refs.app;
        anchorPoint = scrollTop;
        if (scrollHeight - scrollTop < offsetHeight + 50) {
          this.getNextFlockPage();
        }
        this.videoAutoplay();
      }, 200);
    },
    videoAutoplay() {
      if (this.currentVideoIndex < 0) return;
      const video = document.querySelector("#video" + this.currentVideoIndex);
      const { height, top } = video.getBoundingClientRect();
      if (
        top < (-height * 4) / 5 ||
        top > window.innerHeight - (height * 1) / 5
      ) {
        this.currentVideoIndex = -1;
      }
    },
    videoClick(e) {
      const { currentVideoIndex } = this;
      const { index } = e;
      if (index === currentVideoIndex) return;
      this.currentVideoIndex = index;
    },
    toDownload() {
      window.open(this.wap_share_url);
    },
    cardClick({ url }) {
      if (shouldCache) {
        sessionStorage.setItem("top", this.channelId + "," + anchorPoint);
        sessionStorage.setItem("$data", JSON.stringify(this.$data));
        sessionStorage.setItem(
          "requestParam",
          JSON.stringify(this.requestParam)
        );
      }
      window.open(url);
    },
  },
};
</script>

<style lang="less">
@import url(./mixins.less);

* {
  padding: 0;
  margin: 0;
  font-family: Helvetica, Arial, Sans-Serif;
}

a {
  text-decoration: none;
}

.g-background-cover {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.g-wrap-margin {
  margin: 0 40 / @ratio;
}

.g-wrap-padding {
  padding: 0 40 / @ratio;
}

.text-clamp {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.half-pixel-bottom-border {
  position: relative;
}

.half-pixel-bottom-border::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  background-color: #e6e6e6;
  transform: scaleY(0.5);
  transform-origin: 50% 0;
}

.half-pixel-border {
  position: relative;
}

.half-pixel-border::before {
  content: "";
  position: absolute;
  box-sizing: border-box;
  left: 0;
  top: 0;
  width: 200%;
  height: 200%;
  border-radius: inherit;
  transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
  transform: scale(0.5, 0.5);
  -webkit-transform: scale(0.5, 0.5);
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.g-card-title {
  font-size: 36 / @ratio;
  font-weight: bold;
  color: @txtColor;
  letter-spacing: 1 / @ratio;
}

.g-text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.modal {
  visibility: hidden;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  opacity: 0;
  transition: opacity 0.5s, visibility 0.5s;
}

.modal.showUp {
  visibility: visible;
  opacity: 1;
}

div {
  word-break: break-all;
}

// 组件page-loading样式，因为在组件嵌套中无法父组件无法控制自组件样式
// 而且这个组件很多页面都需要，所以写在这里
.page-loading {
  background-color: #fff;
  transition: all 0.2s;
  z-index: 100;
  .bottom-loading {
    position: absolute;
    top: 50%;
    width: 100%;
    .webkitCss(transform, translate3d(0, -50%, 0));
  }
}

#app {
  height: 100vh;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  background-color: #fff;
}

.flock-list {
  position: relative;
  padding-top: 34 / @ratio;
  padding-bottom: 42px;
  background-color: #fff;
}

.flock-join-popup {
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 580 / @ratio;
  padding-bottom: 52 / @ratio;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 8 / @ratio 40 / @ratio 0 rgba(0, 0, 0, 0.5);
  border-radius: 16 / @ratio;
  .webkitCss(transform, translate3d(-50%, -50%, 0));
  button {
    .flex();
    .webkitCss(align-items, center);
    .webkitCss(justify-content, center);
    height: 100 / @ratio;
    margin: 32 / @ratio 52 / @ratio 0;
    color: white;
    line-height: 100 / @ratio;
    font-weight: bold;
    background-color: rgba(59, 59, 59, 1);
    box-shadow: 0 8 / @ratio 12 / @ratio 0 rgba(0, 0, 0, 0.3);
    border-radius: 48 / @ratio;
    img {
      .square(28 / @ratio);
      margin-right: 12 / @ratio;
    }
    &::after {
      border: none;
    }
  }
}

.flock-join-popup-close {
  display: block;
  margin: 20 / @ratio 20 / @ratio 12 / @ratio auto;
  .square(64 / @ratio);
}

.flock-join-popup-cover {
  .flex();
  margin: 0 52 / @ratio;
  padding-bottom: 32 / @ratio;
  img {
    .webkitCss(flex, 0 0 auto);
    .square(120 / @ratio);
    border-radius: 20 / @ratio;
  }
}

.flock-join-popup-title {
  .webkitCss(flex, 1 1 auto);
  margin-left: 24 / @ratio;
  span {
    display: block;
    margin-bottom: 4 / @ratio;
    font-size: 36 / @ratio;
    font-weight: bold;
    color: @txtColor;
    line-height: 46 / @ratio;
    letter-spacing: 1 / @ratio;
    text-shadow: 0 0 28 / @ratio rgba(0, 0, 0, 0.1);
    width: 90%;
  }
}
.flock-join-popup-span {
  min-height: 230 / @ratio;
  margin: 32 / @ratio 52 / @ratio 0;
  font-size: 28 / @ratio;
  line-height: 46 / @ratio;
  color: @txtColor;
  // -webkit-line-clamp: 4;
}

.flock-publish-post {
  .flex();
  .webkitCss(align-items, center);
  .webkitCss(justify-content, center);
  position: fixed;
  right: 42 / @ratio;
  bottom: 64 / @ratio;
  .pill(168 / @ratio, 76 / @ratio);
  font-size: 28 / @ratio;
  color: #00abff;
  line-height: 76 / @ratio;
  background-color: #fff;
  box-shadow: 0 8 / @ratio 20 / @ratio 0 rgba(25, 37, 55, 0.16);
  opacity: 0.96;
  img {
    .square(28 / @ratio);
    margin-right: 12 / @ratio;
  }
}

.flock-card-transition {
  transition: transform 0.3s;
}

.flock-publish-popup {
  .flex();
  position: fixed;
  left: 40 / @ratio;
  bottom: 40 / @ratio;
  width: 670 / @ratio;
  height: 136 / @ratio;
  font-size: 28 / @ratio;
  color: rgba(102, 102, 102, 1);
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 0 40 / @ratio 0 rgba(0, 0, 0, 0.2);
  border-radius: 16 / @ratio;
  border: 1 / @ratio solid rgba(230, 230, 230, 1);
  div {
    .webkitCss(flex, 1 1 auto);
    .flex();
    .webkitCss(align-items, center);
    .webkitCss(justify-content, center);
  }
  img {
    .square(68 / @ratio);
  }
  span {
    position: absolute;
    left: 50%;
    top: 38 / @ratio;
    width: 2 / @ratio;
    height: 60 / @ratio;
    background-color: #e6e6e6;
  }
}

.flock-publish-modal {
  background-color: transparent;
}

.video-comp .video-comp-media {
  width: 670 / @ratio;
  height: 416 / @ratio;
  border-radius: 12 / @ratio;
  &::before {
    border-radius: 24 / @ratio;
  }
}

// 这个是因为设计要求安卓需要与ios不同的样式
// 而放在flock-card里面无法对自组件生效，所以放在这里
.flock-card-android {
  .g-card-title {
    font-weight: 400;
    letter-spacing: 0;
    line-height: 50 / @ratio;
  }
  .flock-card-footer-status {
    padding: 16 / @ratio 0;
  }
  .flock-card-header {
    font-size: 24 / @ratio;
  }
  .flock-card-footer {
    &::before {
      height: 2px;
    }
  }
}

.flock-sketch {
  box-sizing: border-box;
  z-index: 10;
  padding-top: 5 / @ratio;
  background-color: #fff;
  .webkitCss(transform, translateZ(0));
  transition: opacity 0.2s, visibility 0.2s;
  img {
    width: 750 / @ratio;
    height: 1266 / @ratio;
  }
}

.wrong-channel-id {
  padding: 100 / @ratio 0;
  font-size: 26 / @ratio;
  text-align: center;
  color: rgba(171, 171, 171, 1);
}
</style>
